import {Redirect} from 'react-router-dom';

import PropTypes from 'prop-types';
import UserRoute from './UserRoute';

import usePermissions from 'hooks/usePermissions';

const UserManageRoute = ({component, ...rest}) => {
  const {canViewUsers} = usePermissions();

  if (canViewUsers) return <UserRoute {...rest} ManagerComponent={component} />;

  return <Redirect to={{pathname: '/dashboard'}} />;
};

UserManageRoute.propTypes = {
  component: PropTypes.func.isRequired,
};

export default UserManageRoute;
